import { Share2, X } from "lucide-react";
import type { ReactElement } from "react";

import { AvatarStack } from "./AvatarStack";
import type { CompetitionAgent } from "./AvatarStack";

export type { CompetitionAgent };

export function CelebrationBanner({
  agents,
  onDismiss,
  onShare,
}: {
  agents: CompetitionAgent[];
  onDismiss?: () => void;
  onShare?: () => void;
}): ReactElement {
  return (
    <div
      className="rounded-3xl bg-panel-ink px-5 py-5 text-panel-ink-foreground sm:px-7"
      data-testid="offers-celebration"
    >
      <div className="flex items-center justify-between gap-5">
        <div>
          <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-success">
            Agents compete. You choose.
          </p>
          <p className="mt-1 text-xl font-semibold tracking-tight">
            {agents.length} {agents.length === 1 ? "agent is" : "agents are"}{" "}
            competing for you
          </p>
        </div>
        <AvatarStack agents={agents} />
        <div className="flex shrink-0 items-center gap-1">
          {onShare ? (
            <button
              className="inline-flex min-h-10 items-center gap-1 rounded-full px-3 text-xs font-semibold text-panel-ink-foreground transition-[color] hover:text-success focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring motion-reduce:transition-none"
              data-testid="offers-celebration-share"
              onClick={onShare}
              type="button"
            >
              <Share2 aria-hidden="true" className="h-3.5 w-3.5" />
              Share
            </button>
          ) : null}
          {onDismiss && (
            <button
              aria-label="Dismiss"
              className="flex size-10 shrink-0 items-center justify-center rounded-full text-panel-ink-foreground/70 transition-[color,background-color] hover:bg-panel-ink-foreground/10 hover:text-panel-ink-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring motion-reduce:transition-none"
              data-testid="offers-celebration-dismiss"
              onClick={onDismiss}
              type="button"
            >
              <X aria-hidden="true" className="size-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
